import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class EmojiData extends Plugin {
	init() {
		const editor = this.editor;

		editor.plugins.get("Emoji").addItems("Smileys & Emotion", [
		  { title: "grinning face", character: "😀" },
		  { title: "grinning face with big eyes", character: "😃" },
		  { title: "grinning face with smiling eyes", character: "😄" },
		  { title: "beaming face with smiling eyes", character: "😁" },
		  { title: "grinning squinting face", character: "😆" },
		  { title: "grinning face with sweat", character: "😅" },
		  { title: "rolling on the floor laughing", character: "🤣" },
		  { title: "face with tears of joy", character: "😂" },
		  { title: "slightly smiling face", character: "🙂" },
		  { title: "upside-down face", character: "🙃" },
		  { title: "winking face", character: "😉" },
		  { title: "smiling face with smiling eyes", character: "😊" },
		  { title: "smiling face with halo", character: "😇" },
		  { title: "smiling face with hearts", character: "🥰" },
		  { title: "smiling face with heart-eyes", character: "😍" },
		  { title: "star-struck", character: "🤩" },
		  { title: "face blowing a kiss", character: "😘" },
		  { title: "kissing face", character: "😗" },
		  { title: "smiling face", character: "☺️" },
		  { title: "kissing face with closed eyes", character: "😚" },
		  { title: "kissing face with smiling eyes", character: "😙" },
		  { title: "face savoring food", character: "😋" },
		  { title: "face with tongue", character: "😛" },
		  { title: "winking face with tongue", character: "😜" },
		  { title: "zany face", character: "🤪" },
		  { title: "squinting face with tongue", character: "😝" },
		  { title: "money-mouth face", character: "🤑" },
		  { title: "hugging face", character: "🤗" },
		  { title: "face with hand over mouth", character: "🤭" },
		  { title: "shushing face", character: "🤫" },
		  { title: "thinking face", character: "🤔" },
		  { title: "zipper-mouth face", character: "🤐" },
		  { title: "face with raised eyebrow", character: "🤨" },
		  { title: "neutral face", character: "😐" },
		  { title: "expressionless face", character: "😑" },
		  { title: "face without mouth", character: "😶" },
		  { title: "smirking face", character: "😏" },
		  { title: "unamused face", character: "😒" },
		  { title: "face with rolling eyes", character: "🙄" },
		  { title: "grimacing face", character: "😬" },
		  { title: "lying face", character: "🤥" },
		  { title: "relieved face", character: "😌" },
		  { title: "pensive face", character: "😔" },
		  { title: "sleepy face", character: "😪" },
		  { title: "drooling face", character: "🤤" },
		  { title: "sleeping face", character: "😴" },
		  { title: "face with medical mask", character: "😷" },
		  { title: "face with thermometer", character: "🤒" },
		  { title: "face with head-bandage", character: "🤕" },
		  { title: "nauseated face", character: "🤢" },
		  { title: "face vomiting", character: "🤮" },
		  { title: "sneezing face", character: "🤧" },
		  { title: "hot face", character: "🥵" },
		  { title: "cold face", character: "🥶" },
		  { title: "woozy face", character: "🥴" },
		  { title: "dizzy face", character: "😵" },
		  { title: "exploding head", character: "🤯" },
		  { title: "cowboy hat face", character: "🤠" },
		  { title: "partying face", character: "🥳" },
		  { title: "smiling face with sunglasses", character: "😎" },
		  { title: "nerd face", character: "🤓" },
		  { title: "face with monocle", character: "🧐" },
		  { title: "confused face", character: "😕" },
		  { title: "worried face", character: "😟" },
		  { title: "slightly frowning face", character: "🙁" },
		  { title: "frowning face", character: "☹️" },
		  { title: "face with open mouth", character: "😮" },
		  { title: "hushed face", character: "😯" },
		  { title: "astonished face", character: "😲" },
		  { title: "flushed face", character: "😳" },
		  { title: "pleading face", character: "🥺" },
		  { title: "frowning face with open mouth", character: "😦" },
		  { title: "anguished face", character: "😧" },
		  { title: "fearful face", character: "😨" },
		  { title: "anxious face with sweat", character: "😰" },
		  { title: "sad but relieved face", character: "😥" },
		  { title: "crying face", character: "😢" },
		  { title: "loudly crying face", character: "😭" },
		  { title: "face screaming in fear", character: "😱" },
		  { title: "confounded face", character: "😖" },
		  { title: "persevering face", character: "😣" },
		  { title: "disappointed face", character: "😞" },
		  { title: "downcast face with sweat", character: "😓" },
		  { title: "weary face", character: "😩" },
		  { title: "tired face", character: "😫" },
		  { title: "yawning face", character: "🥱" },
		  { title: "face with steam from nose", character: "😤" },
		  { title: "pouting face", character: "😡" },
		  { title: "angry face", character: "😠" },
		  { title: "face with symbols on mouth", character: "🤬" },
		  { title: "smiling face with horns", character: "😈" },
		  { title: "angry face with horns", character: "👿" },
		  { title: "skull", character: "💀" },
		  { title: "skull and crossbones", character: "☠️" },
		  { title: "pile of poo", character: "💩" },
		  { title: "clown face", character: "🤡" },
		  { title: "ogre", character: "👹" },
		  { title: "goblin", character: "👺" },
		  { title: "ghost", character: "👻" },
		  { title: "alien", character: "👽" },
		  { title: "alien monster", character: "👾" },
		  { title: "robot", character: "🤖" },
		  { title: "grinning cat", character: "😺" },
		  { title: "grinning cat with smiling eyes", character: "😸" },
		  { title: "cat with tears of joy", character: "😹" },
		  { title: "smiling cat with heart-eyes", character: "😻" },
		  { title: "cat with wry smile", character: "😼" },
		  { title: "kissing cat", character: "😽" },
		  { title: "weary cat", character: "🙀" },
		  { title: "crying cat", character: "😿" },
		  { title: "pouting cat", character: "😾" },
		  { title: "see-no-evil monkey", character: "🙈" },
		  { title: "hear-no-evil monkey", character: "🙉" },
		  { title: "speak-no-evil monkey", character: "🙊" },
		  { title: "kiss mark", character: "💋" },
		  { title: "love letter", character: "💌" },
		  { title: "heart with arrow", character: "💘" },
		  { title: "heart with ribbon", character: "💝" },
		  { title: "sparkling heart", character: "💖" },
		  { title: "growing heart", character: "💗" },
		  { title: "beating heart", character: "💓" },
		  { title: "revolving hearts", character: "💞" },
		  { title: "two hearts", character: "💕" },
		  { title: "heart decoration", character: "💟" },
		  { title: "heart exclamation", character: "❣️" },
		  { title: "broken heart", character: "💔" },
		  { title: "red heart", character: "❤️" },
		  { title: "orange heart", character: "🧡" },
		  { title: "yellow heart", character: "💛" },
		  { title: "green heart", character: "💚" },
		  { title: "blue heart", character: "💙" },
		  { title: "purple heart", character: "💜" },
		  { title: "brown heart", character: "🤎" },
		  { title: "black heart", character: "🖤" },
		  { title: "white heart", character: "🤍" },
		  { title: "hundred points", character: "💯" },
		  { title: "anger symbol", character: "💢" },
		  { title: "collision", character: "💥" },
		  { title: "dizzy", character: "💫" },
		  { title: "sweat droplets", character: "💦" },
		  { title: "dashing away", character: "💨" },
		  { title: "hole", character: "🕳️" },
		  { title: "bomb", character: "💣" },
		  { title: "speech balloon", character: "💬" },
		  { title: "eye in speech bubble", character: "👁️‍🗨️" },
		  { title: "left speech bubble", character: "🗨️" },
		  { title: "right anger bubble", character: "🗯️" },
		  { title: "thought balloon", character: "💭" },
		  { title: "zzz", character: "💤" },
		]);


		editor.plugins.get("Emoji").addItems("People & Body", [
		  { title: "waving hand", character: "👋" },
		  { title: "raised back of hand", character: "🤚" },
		  { title: "hand with fingers splayed", character: "🖐️" },
		  { title: "raised hand", character: "✋" },
		  { title: "vulcan salute", character: "🖖" },
		  { title: "ok hand", character: "👌" },
		  { title: "pinching hand", character: "🤏" },
		  { title: "victory hand", character: "✌️" },
		  { title: "crossed fingers", character: "🤞" },
		  { title: "love-you gesture", character: "🤟" },
		  { title: "sign of the horns", character: "🤘" },
		  { title: "call me hand", character: "🤙" },
		  { title: "backhand index pointing left", character: "👈" },
		  { title: "backhand index pointing right", character: "👉" },
		  { title: "backhand index pointing up", character: "👆" },
		  { title: "middle finger", character: "🖕" },
		  { title: "backhand index pointing down", character: "👇" },
		  { title: "index pointing up", character: "☝️" },
		  { title: "thumbs up", character: "👍" },
		  { title: "thumbs down", character: "👎" },
		  { title: "raised fist", character: "✊" },
		  { title: "oncoming fist", character: "👊" },
		  { title: "left-facing fist", character: "🤛" },
		  { title: "right-facing fist", character: "🤜" },
		  { title: "clapping hands", character: "👏" },
		  { title: "raising hands", character: "🙌" },
		  { title: "open hands", character: "👐" },
		  { title: "palms up together", character: "🤲" },
		  { title: "handshake", character: "🤝" },
		  { title: "folded hands", character: "🙏" },
		  { title: "writing hand", character: "✍️" },
		  { title: "nail polish", character: "💅" },
		  { title: "selfie", character: "🤳" },
		  { title: "flexed biceps", character: "💪" },
		  { title: "mechanical arm", character: "🦾" },
		  { title: "mechanical leg", character: "🦿" },
		  { title: "leg", character: "🦵" },
		  { title: "foot", character: "🦶" },
		  { title: "ear", character: "👂" },
		  { title: "ear with hearing aid", character: "🦻" },
		  { title: "nose", character: "👃" },
		  { title: "brain", character: "🧠" },
		  { title: "tooth", character: "🦷" },
		  { title: "bone", character: "🦴" },
		  { title: "eyes", character: "👀" },
		  { title: "eye", character: "👁️" },
		  { title: "tongue", character: "👅" },
		  { title: "mouth", character: "👄" },
		  { title: "baby", character: "👶" },
		  { title: "child", character: "🧒" },
		  { title: "boy", character: "👦" },
		  { title: "girl", character: "👧" },
		  { title: "person", character: "🧑" },
		  { title: "person with blond hair", character: "👱" },
		  { title: "man", character: "👨" },
		  { title: "man with beard", character: "🧔" },
		  { title: "man with red hair", character: "👨‍🦰" },
		  { title: "man with curly hair", character: "👨‍🦱" },
		  { title: "man with white hair", character: "👨‍🦳" },
		  { title: "man with no hair", character: "👨‍🦲" },
		  { title: "woman", character: "👩" },
		  { title: "woman with red hair", character: "👩‍🦰" },
		  { title: "woman with curly hair", character: "👩‍🦱" },
		  { title: "woman with white hair", character: "👩‍🦳" },
		  { title: "woman with no hair", character: "👩‍🦲" },
		  { title: "woman with blond hair", character: "👱‍♀️" },
		  { title: "man with blond hair", character: "👱‍♂️" },
		  { title: "older person", character: "🧓" },
		  { title: "old man", character: "👴" },
		  { title: "old woman", character: "👵" },
		  { title: "person frowning", character: "🙍" },
		  { title: "man frowning", character: "🙍‍♂️" },
		  { title: "woman frowning", character: "🙍‍♀️" },
		  { title: "person pouting", character: "🙎" },
		  { title: "man pouting", character: "🙎‍♂️" },
		  { title: "woman pouting", character: "🙎‍♀️" },
		  { title: "person gesturing no", character: "🙅" },
		  { title: "man gesturing no", character: "🙅‍♂️" },
		  { title: "woman gesturing no", character: "🙅‍♀️" },
		  { title: "person gesturing ok", character: "🙆" },
		  { title: "man gesturing ok", character: "🙆‍♂️" },
		  { title: "woman gesturing ok", character: "🙆‍♀️" },
		  { title: "person tipping hand", character: "💁" },
		  { title: "man tipping hand", character: "💁‍♂️" },
		  { title: "woman tipping hand", character: "💁‍♀️" },
		  { title: "person raising hand", character: "🙋" },
		  { title: "man raising hand", character: "🙋‍♂️" },
		  { title: "woman raising hand", character: "🙋‍♀️" },
		  { title: "deaf person", character: "🧏" },
		  { title: "deaf man", character: "🧏‍♂️" },
		  { title: "deaf woman", character: "🧏‍♀️" },
		  { title: "person bowing", character: "🙇" },
		  { title: "man bowing", character: "🙇‍♂️" },
		  { title: "woman bowing", character: "🙇‍♀️" },
		  { title: "person facepalming", character: "🤦" },
		  { title: "man facepalming", character: "🤦‍♂️" },
		  { title: "woman facepalming", character: "🤦‍♀️" },
		  { title: "person shrugging", character: "🤷" },
		  { title: "man shrugging", character: "🤷‍♂️" },
		  { title: "woman shrugging", character: "🤷‍♀️" },
		  { title: "man health worker", character: "👨‍⚕️" },
		  { title: "woman health worker", character: "👩‍⚕️" },
		  { title: "man student", character: "👨‍🎓" },
		  { title: "woman student", character: "👩‍🎓" },
		  { title: "man teacher", character: "👨‍🏫" },
		  { title: "woman teacher", character: "👩‍🏫" },
		  { title: "man judge", character: "👨‍⚖️" },
		  { title: "woman judge", character: "👩‍⚖️" },
		  { title: "man farmer", character: "👨‍🌾" },
		  { title: "woman farmer", character: "👩‍🌾" },
		  { title: "man cook", character: "👨‍🍳" },
		  { title: "woman cook", character: "👩‍🍳" },
		  { title: "man mechanic", character: "👨‍🔧" },
		  { title: "woman mechanic", character: "👩‍🔧" },
		  { title: "man factory worker", character: "👨‍🏭" },
		  { title: "woman factory worker", character: "👩‍🏭" },
		  { title: "man office worker", character: "👨‍💼" },
		  { title: "woman office worker", character: "👩‍💼" },
		  { title: "man scientist", character: "👨‍🔬" },
		  { title: "woman scientist", character: "👩‍🔬" },
		  { title: "man technologist", character: "👨‍💻" },
		  { title: "woman technologist", character: "👩‍💻" },
		  { title: "man singer", character: "👨‍🎤" },
		  { title: "woman singer", character: "👩‍🎤" },
		  { title: "man artist", character: "👨‍🎨" },
		  { title: "woman artist", character: "👩‍🎨" },
		  { title: "man pilot", character: "👨‍✈️" },
		  { title: "woman pilot", character: "👩‍✈️" },
		  { title: "man astronaut", character: "👨‍🚀" },
		  { title: "woman astronaut", character: "👩‍🚀" },
		  { title: "man firefighter", character: "👨‍🚒" },
		  { title: "woman firefighter", character: "👩‍🚒" },
		  { title: "police officer", character: "👮" },
		  { title: "man police officer", character: "👮‍♂️" },
		  { title: "woman police officer", character: "👮‍♀️" },
		  { title: "detective", character: "🕵️" },
		  { title: "man detective", character: "🕵️‍♂️" },
		  { title: "woman detective", character: "🕵️‍♀️" },
		  { title: "guard", character: "💂" },
		  { title: "man guard", character: "💂‍♂️" },
		  { title: "woman guard", character: "💂‍♀️" },
		  { title: "construction worker", character: "👷" },
		  { title: "man construction worker", character: "👷‍♂️" },
		  { title: "woman construction worker", character: "👷‍♀️" },
		  { title: "prince", character: "🤴" },
		  { title: "princess", character: "👸" },
		  { title: "person wearing turban", character: "👳" },
		  { title: "man wearing turban", character: "👳‍♂️" },
		  { title: "woman wearing turban", character: "👳‍♀️" },
		  { title: "person with skullcap", character: "👲" },
		  { title: "woman with headscarf", character: "🧕" },
		  { title: "person in tuxedo", character: "🤵" },
		  { title: "person with veil", character: "👰" },
		  { title: "pregnant woman", character: "🤰" },
		  { title: "breast-feeding", character: "🤱" },
		  { title: "baby angel", character: "👼" },
		  { title: "santa claus", character: "🎅" },
		  { title: "mrs. claus", character: "🤶" },
		  { title: "superhero", character: "🦸" },
		  { title: "man superhero", character: "🦸‍♂️" },
		  { title: "woman superhero", character: "🦸‍♀️" },
		  { title: "supervillain", character: "🦹" },
		  { title: "man supervillain", character: "🦹‍♂️" },
		  { title: "woman supervillain", character: "🦹‍♀️" },
		  { title: "mage", character: "🧙" },
		  { title: "man mage", character: "🧙‍♂️" },
		  { title: "woman mage", character: "🧙‍♀️" },
		  { title: "fairy", character: "🧚" },
		  { title: "man fairy", character: "🧚‍♂️" },
		  { title: "woman fairy", character: "🧚‍♀️" },
		  { title: "vampire", character: "🧛" },
		  { title: "man vampire", character: "🧛‍♂️" },
		  { title: "woman vampire", character: "🧛‍♀️" },
		  { title: "merperson", character: "🧜" },
		  { title: "merman", character: "🧜‍♂️" },
		  { title: "mermaid", character: "🧜‍♀️" },
		  { title: "elf", character: "🧝" },
		  { title: "man elf", character: "🧝‍♂️" },
		  { title: "woman elf", character: "🧝‍♀️" },
		  { title: "genie", character: "🧞" },
		  { title: "man genie", character: "🧞‍♂️" },
		  { title: "woman genie", character: "🧞‍♀️" },
		  { title: "zombie", character: "🧟" },
		  { title: "man zombie", character: "🧟‍♂️" },
		  { title: "woman zombie", character: "🧟‍♀️" },
		  { title: "person getting massage", character: "💆" },
		  { title: "man getting massage", character: "💆‍♂️" },
		  { title: "woman getting massage", character: "💆‍♀️" },
		  { title: "person getting haircut", character: "💇" },
		  { title: "man getting haircut", character: "💇‍♂️" },
		  { title: "woman getting haircut", character: "💇‍♀️" },
		  { title: "person walking", character: "🚶" },
		  { title: "man walking", character: "🚶‍♂️" },
		  { title: "woman walking", character: "🚶‍♀️" },
		  { title: "person standing", character: "🧍" },
		  { title: "man standing", character: "🧍‍♂️" },
		  { title: "woman standing", character: "🧍‍♀️" },
		  { title: "person kneeling", character: "🧎" },
		  { title: "man kneeling", character: "🧎‍♂️" },
		  { title: "woman kneeling", character: "🧎‍♀️" },
		  { title: "man with white cane", character: "👨‍🦯" },
		  { title: "woman with white cane", character: "👩‍🦯" },
		  { title: "man in motorized wheelchair", character: "👨‍🦼" },
		  { title: "woman in motorized wheelchair", character: "👩‍🦼" },
		  { title: "man in manual wheelchair", character: "👨‍🦽" },
		  { title: "woman in manual wheelchair", character: "👩‍🦽" },
		  { title: "person running", character: "🏃" },
		  { title: "man running", character: "🏃‍♂️" },
		  { title: "woman running", character: "🏃‍♀️" },
		  { title: "woman dancing", character: "💃" },
		  { title: "man dancing", character: "🕺" },
		  { title: "person in suit levitating", character: "🕴️" },
		  { title: "people with bunny ears", character: "👯" },
		  { title: "men with bunny ears", character: "👯‍♂️" },
		  { title: "women with bunny ears", character: "👯‍♀️" },
		  { title: "person in steamy room", character: "🧖" },
		  { title: "man in steamy room", character: "🧖‍♂️" },
		  { title: "woman in steamy room", character: "🧖‍♀️" },
		  { title: "person climbing", character: "🧗" },
		  { title: "man climbing", character: "🧗‍♂️" },
		  { title: "woman climbing", character: "🧗‍♀️" },
		  { title: "person fencing", character: "🤺" },
		  { title: "horse racing", character: "🏇" },
		  { title: "skier", character: "⛷️" },
		  { title: "snowboarder", character: "🏂" },
		  { title: "person golfing", character: "🏌️" },
		  { title: "man golfing", character: "🏌️‍♂️" },
		  { title: "woman golfing", character: "🏌️‍♀️" },
		  { title: "person surfing", character: "🏄" },
		  { title: "man surfing", character: "🏄‍♂️" },
		  { title: "woman surfing", character: "🏄‍♀️" },
		  { title: "person rowing boat", character: "🚣" },
		  { title: "man rowing boat", character: "🚣‍♂️" },
		  { title: "woman rowing boat", character: "🚣‍♀️" },
		  { title: "person swimming", character: "🏊" },
		  { title: "man swimming", character: "🏊‍♂️" },
		  { title: "woman swimming", character: "🏊‍♀️" },
		  { title: "person bouncing ball", character: "⛹️" },
		  { title: "man bouncing ball", character: "⛹️‍♂️" },
		  { title: "woman bouncing ball", character: "⛹️‍♀️" },
		  { title: "person lifting weights", character: "🏋️" },
		  { title: "man lifting weights", character: "🏋️‍♂️" },
		  { title: "woman lifting weights", character: "🏋️‍♀️" },
		  { title: "person biking", character: "🚴" },
		  { title: "man biking", character: "🚴‍♂️" },
		  { title: "woman biking", character: "🚴‍♀️" },
		  { title: "person mountain biking", character: "🚵" },
		  { title: "man mountain biking", character: "🚵‍♂️" },
		  { title: "woman mountain biking", character: "🚵‍♀️" },
		  { title: "person cartwheeling", character: "🤸" },
		  { title: "man cartwheeling", character: "🤸‍♂️" },
		  { title: "woman cartwheeling", character: "🤸‍♀️" },
		  { title: "people wrestling", character: "🤼" },
		  { title: "men wrestling", character: "🤼‍♂️" },
		  { title: "women wrestling", character: "🤼‍♀️" },
		  { title: "person playing water polo", character: "🤽" },
		  { title: "man playing water polo", character: "🤽‍♂️" },
		  { title: "woman playing water polo", character: "🤽‍♀️" },
		  { title: "person playing handball", character: "🤾" },
		  { title: "man playing handball", character: "🤾‍♂️" },
		  { title: "woman playing handball", character: "🤾‍♀️" },
		  { title: "person juggling", character: "🤹" },
		  { title: "man juggling", character: "🤹‍♂️" },
		  { title: "woman juggling", character: "🤹‍♀️" },
		  { title: "person in lotus position", character: "🧘" },
		  { title: "man in lotus position", character: "🧘‍♂️" },
		  { title: "woman in lotus position", character: "🧘‍♀️" },
		  { title: "person taking bath", character: "🛀" },
		  { title: "person in bed", character: "🛌" },
		  { title: "people holding hands", character: "🧑‍🤝‍🧑" },
		  { title: "women holding hands", character: "👭" },
		  { title: "woman and man holding hands", character: "👫" },
		  { title: "men holding hands", character: "👬" },
		  { title: "kiss", character: "💏" },
		  { title: "couple with heart", character: "💑" },
		  { title: "family", character: "👪" },
		  { title: "family: man, woman, boy", character: "👨‍👩‍👦" },
		  { title: "family: man, woman, girl", character: "👨‍👩‍👧" },
		  { title: "family: man, woman, girl, boy", character: "👨‍👩‍👧‍👦" },
		  { title: "family: man, woman, boy, boy", character: "👨‍👩‍👦‍👦" },
		  { title: "family: man, woman, girl, girl", character: "👨‍👩‍👧‍👧" },
		  { title: "family: man, man, boy", character: "👨‍👨‍👦" },
		  { title: "family: man, man, girl", character: "👨‍👨‍👧" },
		  { title: "family: man, man, girl, boy", character: "👨‍👨‍👧‍👦" },
		  { title: "family: man, man, boy, boy", character: "👨‍👨‍👦‍👦" },
		  { title: "family: man, man, girl, girl", character: "👨‍👨‍👧‍👧" },
		  { title: "family: woman, woman, boy", character: "👩‍👩‍👦" },
		  { title: "family: woman, woman, girl", character: "👩‍👩‍👧" },
		  { title: "family: woman, woman, girl, boy", character: "👩‍👩‍👧‍👦" },
		  { title: "family: woman, woman, boy, boy", character: "👩‍👩‍👦‍👦" },
		  { title: "family: woman, woman, girl, girl", character: "👩‍👩‍👧‍👧" },
		  { title: "family: man, boy", character: "👨‍👦" },
		  { title: "family: man, boy, boy", character: "👨‍👦‍👦" },
		  { title: "family: man, girl", character: "👨‍👧" },
		  { title: "family: man, girl, boy", character: "👨‍👧‍👦" },
		  { title: "family: man, girl, girl", character: "👨‍👧‍👧" },
		  { title: "family: woman, boy", character: "👩‍👦" },
		  { title: "family: woman, boy, boy", character: "👩‍👦‍👦" },
		  { title: "family: woman, girl", character: "👩‍👧" },
		  { title: "family: woman, girl, boy", character: "👩‍👧‍👦" },
		  { title: "family: woman, girl, girl", character: "👩‍👧‍👧" },
		  { title: "speaking head", character: "🗣️" },
		  { title: "bust in silhouette", character: "👤" },
		  { title: "busts in silhouette", character: "👥" },
		  { title: "footprints", character: "👣" },
		]);


		editor.plugins.get("Emoji").addItems("Animals & Nature", [
		  { title: "monkey face", character: "🐵" },
		  { title: "monkey", character: "🐒" },
		  { title: "gorilla", character: "🦍" },
		  { title: "orangutan", character: "🦧" },
		  { title: "dog face", character: "🐶" },
		  { title: "dog", character: "🐕" },
		  { title: "guide dog", character: "🦮" },
		  { title: "service dog", character: "🐕‍🦺" },
		  { title: "poodle", character: "🐩" },
		  { title: "wolf", character: "🐺" },
		  { title: "fox", character: "🦊" },
		  { title: "raccoon", character: "🦝" },
		  { title: "cat face", character: "🐱" },
		  { title: "cat", character: "🐈" },
		  { title: "lion", character: "🦁" },
		  { title: "tiger face", character: "🐯" },
		  { title: "tiger", character: "🐅" },
		  { title: "leopard", character: "🐆" },
		  { title: "horse face", character: "🐴" },
		  { title: "horse", character: "🐎" },
		  { title: "unicorn", character: "🦄" },
		  { title: "zebra", character: "🦓" },
		  { title: "deer", character: "🦌" },
		  { title: "cow face", character: "🐮" },
		  { title: "ox", character: "🐂" },
		  { title: "water buffalo", character: "🐃" },
		  { title: "cow", character: "🐄" },
		  { title: "pig face", character: "🐷" },
		  { title: "pig", character: "🐖" },
		  { title: "boar", character: "🐗" },
		  { title: "pig nose", character: "🐽" },
		  { title: "ram", character: "🐏" },
		  { title: "ewe", character: "🐑" },
		  { title: "goat", character: "🐐" },
		  { title: "camel", character: "🐪" },
		  { title: "two-hump camel", character: "🐫" },
		  { title: "llama", character: "🦙" },
		  { title: "giraffe", character: "🦒" },
		  { title: "elephant", character: "🐘" },
		  { title: "rhinoceros", character: "🦏" },
		  { title: "hippopotamus", character: "🦛" },
		  { title: "mouse face", character: "🐭" },
		  { title: "mouse", character: "🐁" },
		  { title: "rat", character: "🐀" },
		  { title: "hamster", character: "🐹" },
		  { title: "rabbit face", character: "🐰" },
		  { title: "rabbit", character: "🐇" },
		  { title: "chipmunk", character: "🐿️" },
		  { title: "hedgehog", character: "🦔" },
		  { title: "bat", character: "🦇" },
		  { title: "bear", character: "🐻" },
		  { title: "koala", character: "🐨" },
		  { title: "panda", character: "🐼" },
		  { title: "sloth", character: "🦥" },
		  { title: "otter", character: "🦦" },
		  { title: "skunk", character: "🦨" },
		  { title: "kangaroo", character: "🦘" },
		  { title: "badger", character: "🦡" },
		  { title: "paw prints", character: "🐾" },
		  { title: "turkey", character: "🦃" },
		  { title: "chicken", character: "🐔" },
		  { title: "rooster", character: "🐓" },
		  { title: "hatching chick", character: "🐣" },
		  { title: "baby chick", character: "🐤" },
		  { title: "front-facing baby chick", character: "🐥" },
		  { title: "bird", character: "🐦" },
		  { title: "penguin", character: "🐧" },
		  { title: "dove", character: "🕊️" },
		  { title: "eagle", character: "🦅" },
		  { title: "duck", character: "🦆" },
		  { title: "swan", character: "🦢" },
		  { title: "owl", character: "🦉" },
		  { title: "flamingo", character: "🦩" },
		  { title: "peacock", character: "🦚" },
		  { title: "parrot", character: "🦜" },
		  { title: "frog", character: "🐸" },
		  { title: "crocodile", character: "🐊" },
		  { title: "turtle", character: "🐢" },
		  { title: "lizard", character: "🦎" },
		  { title: "snake", character: "🐍" },
		  { title: "dragon face", character: "🐲" },
		  { title: "dragon", character: "🐉" },
		  { title: "sauropod", character: "🦕" },
		  { title: "t-rex", character: "🦖" },
		  { title: "spouting whale", character: "🐳" },
		  { title: "whale", character: "🐋" },
		  { title: "dolphin", character: "🐬" },
		  { title: "fish", character: "🐟" },
		  { title: "tropical fish", character: "🐠" },
		  { title: "blowfish", character: "🐡" },
		  { title: "shark", character: "🦈" },
		  { title: "octopus", character: "🐙" },
		  { title: "spiral shell", character: "🐚" },
		  { title: "snail", character: "🐌" },
		  { title: "butterfly", character: "🦋" },
		  { title: "bug", character: "🐛" },
		  { title: "ant", character: "🐜" },
		  { title: "honeybee", character: "🐝" },
		  { title: "lady beetle", character: "🐞" },
		  { title: "cricket", character: "🦗" },
		  { title: "spider", character: "🕷️" },
		  { title: "spider web", character: "🕸️" },
		  { title: "scorpion", character: "🦂" },
		  { title: "mosquito", character: "🦟" },
		  { title: "microbe", character: "🦠" },
		  { title: "bouquet", character: "💐" },
		  { title: "cherry blossom", character: "🌸" },
		  { title: "white flower", character: "💮" },
		  { title: "rosette", character: "🏵️" },
		  { title: "rose", character: "🌹" },
		  { title: "wilted flower", character: "🥀" },
		  { title: "hibiscus", character: "🌺" },
		  { title: "sunflower", character: "🌻" },
		  { title: "blossom", character: "🌼" },
		  { title: "tulip", character: "🌷" },
		  { title: "seedling", character: "🌱" },
		  { title: "evergreen tree", character: "🌲" },
		  { title: "deciduous tree", character: "🌳" },
		  { title: "palm tree", character: "🌴" },
		  { title: "cactus", character: "🌵" },
		  { title: "sheaf of rice", character: "🌾" },
		  { title: "herb", character: "🌿" },
		  { title: "shamrock", character: "☘️" },
		  { title: "four leaf clover", character: "🍀" },
		  { title: "maple leaf", character: "🍁" },
		  { title: "fallen leaf", character: "🍂" },
		  { title: "leaf fluttering in wind", character: "🍃" },
		]);


		editor.plugins.get("Emoji").addItems("Food & Drink", [
		  { title: "grapes", character: "🍇" },
		  { title: "melon", character: "🍈" },
		  { title: "watermelon", character: "🍉" },
		  { title: "tangerine", character: "🍊" },
		  { title: "lemon", character: "🍋" },
		  { title: "banana", character: "🍌" },
		  { title: "pineapple", character: "🍍" },
		  { title: "mango", character: "🥭" },
		  { title: "red apple", character: "🍎" },
		  { title: "green apple", character: "🍏" },
		  { title: "pear", character: "🍐" },
		  { title: "peach", character: "🍑" },
		  { title: "cherries", character: "🍒" },
		  { title: "strawberry", character: "🍓" },
		  { title: "kiwi fruit", character: "🥝" },
		  { title: "tomato", character: "🍅" },
		  { title: "coconut", character: "🥥" },
		  { title: "avocado", character: "🥑" },
		  { title: "eggplant", character: "🍆" },
		  { title: "potato", character: "🥔" },
		  { title: "carrot", character: "🥕" },
		  { title: "ear of corn", character: "🌽" },
		  { title: "hot pepper", character: "🌶️" },
		  { title: "cucumber", character: "🥒" },
		  { title: "leafy green", character: "🥬" },
		  { title: "broccoli", character: "🥦" },
		  { title: "garlic", character: "🧄" },
		  { title: "onion", character: "🧅" },
		  { title: "mushroom", character: "🍄" },
		  { title: "peanuts", character: "🥜" },
		  { title: "chestnut", character: "🌰" },
		  { title: "bread", character: "🍞" },
		  { title: "croissant", character: "🥐" },
		  { title: "baguette bread", character: "🥖" },
		  { title: "pretzel", character: "🥨" },
		  { title: "bagel", character: "🥯" },
		  { title: "pancakes", character: "🥞" },
		  { title: "waffle", character: "🧇" },
		  { title: "cheese wedge", character: "🧀" },
		  { title: "meat on bone", character: "🍖" },
		  { title: "poultry leg", character: "🍗" },
		  { title: "cut of meat", character: "🥩" },
		  { title: "bacon", character: "🥓" },
		  { title: "hamburger", character: "🍔" },
		  { title: "french fries", character: "🍟" },
		  { title: "pizza", character: "🍕" },
		  { title: "hot dog", character: "🌭" },
		  { title: "sandwich", character: "🥪" },
		  { title: "taco", character: "🌮" },
		  { title: "burrito", character: "🌯" },
		  { title: "stuffed flatbread", character: "🥙" },
		  { title: "falafel", character: "🧆" },
		  { title: "egg", character: "🥚" },
		  { title: "cooking", character: "🍳" },
		  { title: "shallow pan of food", character: "🥘" },
		  { title: "pot of food", character: "🍲" },
		  { title: "bowl with spoon", character: "🥣" },
		  { title: "green salad", character: "🥗" },
		  { title: "popcorn", character: "🍿" },
		  { title: "butter", character: "🧈" },
		  { title: "salt", character: "🧂" },
		  { title: "canned food", character: "🥫" },
		  { title: "bento box", character: "🍱" },
		  { title: "rice cracker", character: "🍘" },
		  { title: "rice ball", character: "🍙" },
		  { title: "cooked rice", character: "🍚" },
		  { title: "curry rice", character: "🍛" },
		  { title: "steaming bowl", character: "🍜" },
		  { title: "spaghetti", character: "🍝" },
		  { title: "roasted sweet potato", character: "🍠" },
		  { title: "oden", character: "🍢" },
		  { title: "sushi", character: "🍣" },
		  { title: "fried shrimp", character: "🍤" },
		  { title: "fish cake with swirl", character: "🍥" },
		  { title: "moon cake", character: "🥮" },
		  { title: "dango", character: "🍡" },
		  { title: "dumpling", character: "🥟" },
		  { title: "fortune cookie", character: "🥠" },
		  { title: "takeout box", character: "🥡" },
		  { title: "crab", character: "🦀" },
		  { title: "lobster", character: "🦞" },
		  { title: "shrimp", character: "🦐" },
		  { title: "squid", character: "🦑" },
		  { title: "oyster", character: "🦪" },
		  { title: "soft ice cream", character: "🍦" },
		  { title: "shaved ice", character: "🍧" },
		  { title: "ice cream", character: "🍨" },
		  { title: "doughnut", character: "🍩" },
		  { title: "cookie", character: "🍪" },
		  { title: "birthday cake", character: "🎂" },
		  { title: "shortcake", character: "🍰" },
		  { title: "cupcake", character: "🧁" },
		  { title: "pie", character: "🥧" },
		  { title: "chocolate bar", character: "🍫" },
		  { title: "candy", character: "🍬" },
		  { title: "lollipop", character: "🍭" },
		  { title: "custard", character: "🍮" },
		  { title: "honey pot", character: "🍯" },
		  { title: "baby bottle", character: "🍼" },
		  { title: "glass of milk", character: "🥛" },
		  { title: "hot beverage", character: "☕" },
		  { title: "teacup without handle", character: "🍵" },
		  { title: "sake", character: "🍶" },
		  { title: "bottle with popping cork", character: "🍾" },
		  { title: "wine glass", character: "🍷" },
		  { title: "cocktail glass", character: "🍸" },
		  { title: "tropical drink", character: "🍹" },
		  { title: "beer mug", character: "🍺" },
		  { title: "clinking beer mugs", character: "🍻" },
		  { title: "clinking glasses", character: "🥂" },
		  { title: "tumbler glass", character: "🥃" },
		  { title: "cup with straw", character: "🥤" },
		  { title: "beverage box", character: "🧃" },
		  { title: "mate", character: "🧉" },
		  { title: "ice", character: "🧊" },
		  { title: "chopsticks", character: "🥢" },
		  { title: "fork and knife with plate", character: "🍽️" },
		  { title: "fork and knife", character: "🍴" },
		  { title: "spoon", character: "🥄" },
		  { title: "kitchen knife", character: "🔪" },
		  { title: "amphora", character: "🏺" },
		]);


		editor.plugins.get("Emoji").addItems("Travel & Places", [
		  { title: "globe showing europe-africa", character: "🌍" },
		  { title: "globe showing americas", character: "🌎" },
		  { title: "globe showing asia-australia", character: "🌏" },
		  { title: "globe with meridians", character: "🌐" },
		  { title: "world map", character: "🗺️" },
		  { title: "map of japan", character: "🗾" },
		  { title: "compass", character: "🧭" },
		  { title: "snow-capped mountain", character: "🏔️" },
		  { title: "mountain", character: "⛰️" },
		  { title: "volcano", character: "🌋" },
		  { title: "mount fuji", character: "🗻" },
		  { title: "camping", character: "🏕️" },
		  { title: "beach with umbrella", character: "🏖️" },
		  { title: "desert", character: "🏜️" },
		  { title: "desert island", character: "🏝️" },
		  { title: "national park", character: "🏞️" },
		  { title: "stadium", character: "🏟️" },
		  { title: "classical building", character: "🏛️" },
		  { title: "building construction", character: "🏗️" },
		  { title: "brick", character: "🧱" },
		  { title: "houses", character: "🏘️" },
		  { title: "derelict house", character: "🏚️" },
		  { title: "house", character: "🏠" },
		  { title: "house with garden", character: "🏡" },
		  { title: "office building", character: "🏢" },
		  { title: "japanese post office", character: "🏣" },
		  { title: "post office", character: "🏤" },
		  { title: "hospital", character: "🏥" },
		  { title: "bank", character: "🏦" },
		  { title: "hotel", character: "🏨" },
		  { title: "love hotel", character: "🏩" },
		  { title: "convenience store", character: "🏪" },
		  { title: "school", character: "🏫" },
		  { title: "department store", character: "🏬" },
		  { title: "factory", character: "🏭" },
		  { title: "japanese castle", character: "🏯" },
		  { title: "castle", character: "🏰" },
		  { title: "wedding", character: "💒" },
		  { title: "tokyo tower", character: "🗼" },
		  { title: "statue of liberty", character: "🗽" },
		  { title: "church", character: "⛪" },
		  { title: "mosque", character: "🕌" },
		  { title: "hindu temple", character: "🛕" },
		  { title: "synagogue", character: "🕍" },
		  { title: "shinto shrine", character: "⛩️" },
		  { title: "kaaba", character: "🕋" },
		  { title: "fountain", character: "⛲" },
		  { title: "tent", character: "⛺" },
		  { title: "foggy", character: "🌁" },
		  { title: "night with stars", character: "🌃" },
		  { title: "cityscape", character: "🏙️" },
		  { title: "sunrise over mountains", character: "🌄" },
		  { title: "sunrise", character: "🌅" },
		  { title: "cityscape at dusk", character: "🌆" },
		  { title: "sunset", character: "🌇" },
		  { title: "bridge at night", character: "🌉" },
		  { title: "hot springs", character: "♨️" },
		  { title: "carousel horse", character: "🎠" },
		  { title: "ferris wheel", character: "🎡" },
		  { title: "roller coaster", character: "🎢" },
		  { title: "barber pole", character: "💈" },
		  { title: "circus tent", character: "🎪" },
		  { title: "locomotive", character: "🚂" },
		  { title: "railway car", character: "🚃" },
		  { title: "high-speed train", character: "🚄" },
		  { title: "bullet train", character: "🚅" },
		  { title: "train", character: "🚆" },
		  { title: "metro", character: "🚇" },
		  { title: "light rail", character: "🚈" },
		  { title: "station", character: "🚉" },
		  { title: "tram", character: "🚊" },
		  { title: "monorail", character: "🚝" },
		  { title: "mountain railway", character: "🚞" },
		  { title: "tram car", character: "🚋" },
		  { title: "bus", character: "🚌" },
		  { title: "oncoming bus", character: "🚍" },
		  { title: "trolleybus", character: "🚎" },
		  { title: "minibus", character: "🚐" },
		  { title: "ambulance", character: "🚑" },
		  { title: "fire engine", character: "🚒" },
		  { title: "police car", character: "🚓" },
		  { title: "oncoming police car", character: "🚔" },
		  { title: "taxi", character: "🚕" },
		  { title: "oncoming taxi", character: "🚖" },
		  { title: "automobile", character: "🚗" },
		  { title: "oncoming automobile", character: "🚘" },
		  { title: "sport utility vehicle", character: "🚙" },
		  { title: "delivery truck", character: "🚚" },
		  { title: "articulated lorry", character: "🚛" },
		  { title: "tractor", character: "🚜" },
		  { title: "racing car", character: "🏎️" },
		  { title: "motorcycle", character: "🏍️" },
		  { title: "motor scooter", character: "🛵" },
		  { title: "manual wheelchair", character: "🦽" },
		  { title: "motorized wheelchair", character: "🦼" },
		  { title: "auto rickshaw", character: "🛺" },
		  { title: "bicycle", character: "🚲" },
		  { title: "kick scooter", character: "🛴" },
		  { title: "skateboard", character: "🛹" },
		  { title: "bus stop", character: "🚏" },
		  { title: "motorway", character: "🛣️" },
		  { title: "railway track", character: "🛤️" },
		  { title: "oil drum", character: "🛢️" },
		  { title: "fuel pump", character: "⛽" },
		  { title: "police car light", character: "🚨" },
		  { title: "horizontal traffic light", character: "🚥" },
		  { title: "vertical traffic light", character: "🚦" },
		  { title: "stop sign", character: "🛑" },
		  { title: "construction", character: "🚧" },
		  { title: "anchor", character: "⚓" },
		  { title: "sailboat", character: "⛵" },
		  { title: "canoe", character: "🛶" },
		  { title: "speedboat", character: "🚤" },
		  { title: "passenger ship", character: "🛳️" },
		  { title: "ferry", character: "⛴️" },
		  { title: "motor boat", character: "🛥️" },
		  { title: "ship", character: "🚢" },
		  { title: "airplane", character: "✈️" },
		  { title: "small airplane", character: "🛩️" },
		  { title: "airplane departure", character: "🛫" },
		  { title: "airplane arrival", character: "🛬" },
		  { title: "parachute", character: "🪂" },
		  { title: "seat", character: "💺" },
		  { title: "helicopter", character: "🚁" },
		  { title: "suspension railway", character: "🚟" },
		  { title: "mountain cableway", character: "🚠" },
		  { title: "aerial tramway", character: "🚡" },
		  { title: "satellite", character: "🛰️" },
		  { title: "rocket", character: "🚀" },
		  { title: "flying saucer", character: "🛸" },
		  { title: "bellhop bell", character: "🛎️" },
		  { title: "luggage", character: "🧳" },
		  { title: "hourglass done", character: "⌛" },
		  { title: "hourglass not done", character: "⏳" },
		  { title: "watch", character: "⌚" },
		  { title: "alarm clock", character: "⏰" },
		  { title: "stopwatch", character: "⏱️" },
		  { title: "timer clock", character: "⏲️" },
		  { title: "mantelpiece clock", character: "🕰️" },
		  { title: "twelve o’clock", character: "🕛" },
		  { title: "twelve-thirty", character: "🕧" },
		  { title: "one o’clock", character: "🕐" },
		  { title: "one-thirty", character: "🕜" },
		  { title: "two o’clock", character: "🕑" },
		  { title: "two-thirty", character: "🕝" },
		  { title: "three o’clock", character: "🕒" },
		  { title: "three-thirty", character: "🕞" },
		  { title: "four o’clock", character: "🕓" },
		  { title: "four-thirty", character: "🕟" },
		  { title: "five o’clock", character: "🕔" },
		  { title: "five-thirty", character: "🕠" },
		  { title: "six o’clock", character: "🕕" },
		  { title: "six-thirty", character: "🕡" },
		  { title: "seven o’clock", character: "🕖" },
		  { title: "seven-thirty", character: "🕢" },
		  { title: "eight o’clock", character: "🕗" },
		  { title: "eight-thirty", character: "🕣" },
		  { title: "nine o’clock", character: "🕘" },
		  { title: "nine-thirty", character: "🕤" },
		  { title: "ten o’clock", character: "🕙" },
		  { title: "ten-thirty", character: "🕥" },
		  { title: "eleven o’clock", character: "🕚" },
		  { title: "eleven-thirty", character: "🕦" },
		  { title: "new moon", character: "🌑" },
		  { title: "waxing crescent moon", character: "🌒" },
		  { title: "first quarter moon", character: "🌓" },
		  { title: "waxing gibbous moon", character: "🌔" },
		  { title: "full moon", character: "🌕" },
		  { title: "waning gibbous moon", character: "🌖" },
		  { title: "last quarter moon", character: "🌗" },
		  { title: "waning crescent moon", character: "🌘" },
		  { title: "crescent moon", character: "🌙" },
		  { title: "new moon face", character: "🌚" },
		  { title: "first quarter moon face", character: "🌛" },
		  { title: "last quarter moon face", character: "🌜" },
		  { title: "thermometer", character: "🌡️" },
		  { title: "sun", character: "☀️" },
		  { title: "full moon face", character: "🌝" },
		  { title: "sun with face", character: "🌞" },
		  { title: "ringed planet", character: "🪐" },
		  { title: "star", character: "⭐" },
		  { title: "glowing star", character: "🌟" },
		  { title: "shooting star", character: "🌠" },
		  { title: "milky way", character: "🌌" },
		  { title: "cloud", character: "☁️" },
		  { title: "sun behind cloud", character: "⛅" },
		  { title: "cloud with lightning and rain", character: "⛈️" },
		  { title: "sun behind small cloud", character: "🌤️" },
		  { title: "sun behind large cloud", character: "🌥️" },
		  { title: "sun behind rain cloud", character: "🌦️" },
		  { title: "cloud with rain", character: "🌧️" },
		  { title: "cloud with snow", character: "🌨️" },
		  { title: "cloud with lightning", character: "🌩️" },
		  { title: "tornado", character: "🌪️" },
		  { title: "fog", character: "🌫️" },
		  { title: "wind face", character: "🌬️" },
		  { title: "cyclone", character: "🌀" },
		  { title: "rainbow", character: "🌈" },
		  { title: "closed umbrella", character: "🌂" },
		  { title: "umbrella", character: "☂️" },
		  { title: "umbrella with rain drops", character: "☔" },
		  { title: "umbrella on ground", character: "⛱️" },
		  { title: "high voltage", character: "⚡" },
		  { title: "snowflake", character: "❄️" },
		  { title: "snowman", character: "☃️" },
		  { title: "snowman without snow", character: "⛄" },
		  { title: "comet", character: "☄️" },
		  { title: "fire", character: "🔥" },
		  { title: "droplet", character: "💧" },
		  { title: "water wave", character: "🌊" },
		]);


		editor.plugins.get("Emoji").addItems("Activities", [
		  { title: "jack-o-lantern", character: "🎃" },
		  { title: "christmas tree", character: "🎄" },
		  { title: "fireworks", character: "🎆" },
		  { title: "sparkler", character: "🎇" },
		  { title: "firecracker", character: "🧨" },
		  { title: "sparkles", character: "✨" },
		  { title: "balloon", character: "🎈" },
		  { title: "party popper", character: "🎉" },
		  { title: "confetti ball", character: "🎊" },
		  { title: "tanabata tree", character: "🎋" },
		  { title: "pine decoration", character: "🎍" },
		  { title: "japanese dolls", character: "🎎" },
		  { title: "carp streamer", character: "🎏" },
		  { title: "wind chime", character: "🎐" },
		  { title: "moon viewing ceremony", character: "🎑" },
		  { title: "red envelope", character: "🧧" },
		  { title: "ribbon", character: "🎀" },
		  { title: "wrapped gift", character: "🎁" },
		  { title: "reminder ribbon", character: "🎗️" },
		  { title: "admission tickets", character: "🎟️" },
		  { title: "ticket", character: "🎫" },
		  { title: "military medal", character: "🎖️" },
		  { title: "trophy", character: "🏆" },
		  { title: "sports medal", character: "🏅" },
		  { title: "1st place medal", character: "🥇" },
		  { title: "2nd place medal", character: "🥈" },
		  { title: "3rd place medal", character: "🥉" },
		  { title: "soccer ball", character: "⚽" },
		  { title: "baseball", character: "⚾" },
		  { title: "softball", character: "🥎" },
		  { title: "basketball", character: "🏀" },
		  { title: "volleyball", character: "🏐" },
		  { title: "american football", character: "🏈" },
		  { title: "rugby football", character: "🏉" },
		  { title: "tennis", character: "🎾" },
		  { title: "flying disc", character: "🥏" },
		  { title: "bowling", character: "🎳" },
		  { title: "cricket game", character: "🏏" },
		  { title: "field hockey", character: "🏑" },
		  { title: "ice hockey", character: "🏒" },
		  { title: "lacrosse", character: "🥍" },
		  { title: "ping pong", character: "🏓" },
		  { title: "badminton", character: "🏸" },
		  { title: "boxing glove", character: "🥊" },
		  { title: "martial arts uniform", character: "🥋" },
		  { title: "goal net", character: "🥅" },
		  { title: "flag in hole", character: "⛳" },
		  { title: "ice skate", character: "⛸️" },
		  { title: "fishing pole", character: "🎣" },
		  { title: "diving mask", character: "🤿" },
		  { title: "running shirt", character: "🎽" },
		  { title: "skis", character: "🎿" },
		  { title: "sled", character: "🛷" },
		  { title: "curling stone", character: "🥌" },
		  { title: "direct hit", character: "🎯" },
		  { title: "yo-yo", character: "🪀" },
		  { title: "kite", character: "🪁" },
		  { title: "pool 8 ball", character: "🎱" },
		  { title: "crystal ball", character: "🔮" },
		  { title: "nazar amulet", character: "🧿" },
		  { title: "video game", character: "🎮" },
		  { title: "joystick", character: "🕹️" },
		  { title: "slot machine", character: "🎰" },
		  { title: "game die", character: "🎲" },
		  { title: "puzzle piece", character: "🧩" },
		  { title: "teddy bear", character: "🧸" },
		  { title: "spade suit", character: "♠️" },
		  { title: "heart suit", character: "♥️" },
		  { title: "diamond suit", character: "♦️" },
		  { title: "club suit", character: "♣️" },
		  { title: "chess pawn", character: "♟️" },
		  { title: "joker", character: "🃏" },
		  { title: "mahjong red dragon", character: "🀄" },
		  { title: "flower playing cards", character: "🎴" },
		  { title: "performing arts", character: "🎭" },
		  { title: "framed picture", character: "🖼️" },
		  { title: "artist palette", character: "🎨" },
		  { title: "thread", character: "🧵" },
		  { title: "yarn", character: "🧶" },
		]);


		editor.plugins.get("Emoji").addItems("Objects", [
		  { title: "glasses", character: "👓" },
		  { title: "sunglasses", character: "🕶️" },
		  { title: "goggles", character: "🥽" },
		  { title: "lab coat", character: "🥼" },
		  { title: "safety vest", character: "🦺" },
		  { title: "necktie", character: "👔" },
		  { title: "t-shirt", character: "👕" },
		  { title: "jeans", character: "👖" },
		  { title: "scarf", character: "🧣" },
		  { title: "gloves", character: "🧤" },
		  { title: "coat", character: "🧥" },
		  { title: "socks", character: "🧦" },
		  { title: "dress", character: "👗" },
		  { title: "kimono", character: "👘" },
		  { title: "sari", character: "🥻" },
		  { title: "one-piece swimsuit", character: "🩱" },
		  { title: "briefs", character: "🩲" },
		  { title: "shorts", character: "🩳" },
		  { title: "bikini", character: "👙" },
		  { title: "woman’s clothes", character: "👚" },
		  { title: "purse", character: "👛" },
		  { title: "handbag", character: "👜" },
		  { title: "clutch bag", character: "👝" },
		  { title: "shopping bags", character: "🛍️" },
		  { title: "backpack", character: "🎒" },
		  { title: "man’s shoe", character: "👞" },
		  { title: "running shoe", character: "👟" },
		  { title: "hiking boot", character: "🥾" },
		  { title: "flat shoe", character: "🥿" },
		  { title: "high-heeled shoe", character: "👠" },
		  { title: "woman’s sandal", character: "👡" },
		  { title: "ballet shoes", character: "🩰" },
		  { title: "woman’s boot", character: "👢" },
		  { title: "crown", character: "👑" },
		  { title: "woman’s hat", character: "👒" },
		  { title: "top hat", character: "🎩" },
		  { title: "graduation cap", character: "🎓" },
		  { title: "billed cap", character: "🧢" },
		  { title: "rescue worker’s helmet", character: "⛑️" },
		  { title: "prayer beads", character: "📿" },
		  { title: "lipstick", character: "💄" },
		  { title: "ring", character: "💍" },
		  { title: "gem stone", character: "💎" },
		  { title: "muted speaker", character: "🔇" },
		  { title: "speaker low volume", character: "🔈" },
		  { title: "speaker medium volume", character: "🔉" },
		  { title: "speaker high volume", character: "🔊" },
		  { title: "loudspeaker", character: "📢" },
		  { title: "megaphone", character: "📣" },
		  { title: "postal horn", character: "📯" },
		  { title: "bell", character: "🔔" },
		  { title: "bell with slash", character: "🔕" },
		  { title: "musical score", character: "🎼" },
		  { title: "musical note", character: "🎵" },
		  { title: "musical notes", character: "🎶" },
		  { title: "studio microphone", character: "🎙️" },
		  { title: "level slider", character: "🎚️" },
		  { title: "control knobs", character: "🎛️" },
		  { title: "microphone", character: "🎤" },
		  { title: "headphone", character: "🎧" },
		  { title: "radio", character: "📻" },
		  { title: "saxophone", character: "🎷" },
		  { title: "guitar", character: "🎸" },
		  { title: "musical keyboard", character: "🎹" },
		  { title: "trumpet", character: "🎺" },
		  { title: "violin", character: "🎻" },
		  { title: "banjo", character: "🪕" },
		  { title: "drum", character: "🥁" },
		  { title: "mobile phone", character: "📱" },
		  { title: "mobile phone with arrow", character: "📲" },
		  { title: "telephone", character: "☎️" },
		  { title: "telephone receiver", character: "📞" },
		  { title: "pager", character: "📟" },
		  { title: "fax machine", character: "📠" },
		  { title: "battery", character: "🔋" },
		  { title: "electric plug", character: "🔌" },
		  { title: "laptop", character: "💻" },
		  { title: "desktop computer", character: "🖥️" },
		  { title: "printer", character: "🖨️" },
		  { title: "keyboard", character: "⌨️" },
		  { title: "computer mouse", character: "🖱️" },
		  { title: "trackball", character: "🖲️" },
		  { title: "computer disk", character: "💽" },
		  { title: "floppy disk", character: "💾" },
		  { title: "optical disk", character: "💿" },
		  { title: "dvd", character: "📀" },
		  { title: "abacus", character: "🧮" },
		  { title: "movie camera", character: "🎥" },
		  { title: "film frames", character: "🎞️" },
		  { title: "film projector", character: "📽️" },
		  { title: "clapper board", character: "🎬" },
		  { title: "television", character: "📺" },
		  { title: "camera", character: "📷" },
		  { title: "camera with flash", character: "📸" },
		  { title: "video camera", character: "📹" },
		  { title: "videocassette", character: "📼" },
		  { title: "magnifying glass tilted left", character: "🔍" },
		  { title: "magnifying glass tilted right", character: "🔎" },
		  { title: "candle", character: "🕯️" },
		  { title: "light bulb", character: "💡" },
		  { title: "flashlight", character: "🔦" },
		  { title: "red paper lantern", character: "🏮" },
		  { title: "diya lamp", character: "🪔" },
		  { title: "notebook with decorative cover", character: "📔" },
		  { title: "closed book", character: "📕" },
		  { title: "open book", character: "📖" },
		  { title: "green book", character: "📗" },
		  { title: "blue book", character: "📘" },
		  { title: "orange book", character: "📙" },
		  { title: "books", character: "📚" },
		  { title: "notebook", character: "📓" },
		  { title: "ledger", character: "📒" },
		  { title: "page with curl", character: "📃" },
		  { title: "scroll", character: "📜" },
		  { title: "page facing up", character: "📄" },
		  { title: "newspaper", character: "📰" },
		  { title: "rolled-up newspaper", character: "🗞️" },
		  { title: "bookmark tabs", character: "📑" },
		  { title: "bookmark", character: "🔖" },
		  { title: "label", character: "🏷️" },
		  { title: "money bag", character: "💰" },
		  { title: "yen banknote", character: "💴" },
		  { title: "dollar banknote", character: "💵" },
		  { title: "euro banknote", character: "💶" },
		  { title: "pound banknote", character: "💷" },
		  { title: "money with wings", character: "💸" },
		  { title: "credit card", character: "💳" },
		  { title: "receipt", character: "🧾" },
		  { title: "chart increasing with yen", character: "💹" },
		  { title: "envelope", character: "✉️" },
		  { title: "e-mail", character: "📧" },
		  { title: "incoming envelope", character: "📨" },
		  { title: "envelope with arrow", character: "📩" },
		  { title: "outbox tray", character: "📤" },
		  { title: "inbox tray", character: "📥" },
		  { title: "package", character: "📦" },
		  { title: "closed mailbox with raised flag", character: "📫" },
		  { title: "closed mailbox with lowered flag", character: "📪" },
		  { title: "open mailbox with raised flag", character: "📬" },
		  { title: "open mailbox with lowered flag", character: "📭" },
		  { title: "postbox", character: "📮" },
		  { title: "ballot box with ballot", character: "🗳️" },
		  { title: "pencil", character: "✏️" },
		  { title: "black nib", character: "✒️" },
		  { title: "fountain pen", character: "🖋️" },
		  { title: "pen", character: "🖊️" },
		  { title: "paintbrush", character: "🖌️" },
		  { title: "crayon", character: "🖍️" },
		  { title: "memo", character: "📝" },
		  { title: "briefcase", character: "💼" },
		  { title: "file folder", character: "📁" },
		  { title: "open file folder", character: "📂" },
		  { title: "card index dividers", character: "🗂️" },
		  { title: "calendar", character: "📅" },
		  { title: "tear-off calendar", character: "📆" },
		  { title: "spiral notepad", character: "🗒️" },
		  { title: "spiral calendar", character: "🗓️" },
		  { title: "card index", character: "📇" },
		  { title: "chart increasing", character: "📈" },
		  { title: "chart decreasing", character: "📉" },
		  { title: "bar chart", character: "📊" },
		  { title: "clipboard", character: "📋" },
		  { title: "pushpin", character: "📌" },
		  { title: "round pushpin", character: "📍" },
		  { title: "paperclip", character: "📎" },
		  { title: "linked paperclips", character: "🖇️" },
		  { title: "straight ruler", character: "📏" },
		  { title: "triangular ruler", character: "📐" },
		  { title: "scissors", character: "✂️" },
		  { title: "card file box", character: "🗃️" },
		  { title: "file cabinet", character: "🗄️" },
		  { title: "wastebasket", character: "🗑️" },
		  { title: "locked", character: "🔒" },
		  { title: "unlocked", character: "🔓" },
		  { title: "locked with pen", character: "🔏" },
		  { title: "locked with key", character: "🔐" },
		  { title: "key", character: "🔑" },
		  { title: "old key", character: "🗝️" },
		  { title: "hammer", character: "🔨" },
		  { title: "axe", character: "🪓" },
		  { title: "pick", character: "⛏️" },
		  { title: "hammer and pick", character: "⚒️" },
		  { title: "hammer and wrench", character: "🛠️" },
		  { title: "dagger", character: "🗡️" },
		  { title: "crossed swords", character: "⚔️" },
		  { title: "pistol", character: "🔫" },
		  { title: "bow and arrow", character: "🏹" },
		  { title: "shield", character: "🛡️" },
		  { title: "wrench", character: "🔧" },
		  { title: "nut and bolt", character: "🔩" },
		  { title: "gear", character: "⚙️" },
		  { title: "clamp", character: "🗜️" },
		  { title: "balance scale", character: "⚖️" },
		  { title: "white cane", character: "🦯" },
		  { title: "link", character: "🔗" },
		  { title: "chains", character: "⛓️" },
		  { title: "toolbox", character: "🧰" },
		  { title: "magnet", character: "🧲" },
		  { title: "alembic", character: "⚗️" },
		  { title: "test tube", character: "🧪" },
		  { title: "petri dish", character: "🧫" },
		  { title: "dna", character: "🧬" },
		  { title: "microscope", character: "🔬" },
		  { title: "telescope", character: "🔭" },
		  { title: "satellite antenna", character: "📡" },
		  { title: "syringe", character: "💉" },
		  { title: "drop of blood", character: "🩸" },
		  { title: "pill", character: "💊" },
		  { title: "adhesive bandage", character: "🩹" },
		  { title: "stethoscope", character: "🩺" },
		  { title: "door", character: "🚪" },
		  { title: "bed", character: "🛏️" },
		  { title: "couch and lamp", character: "🛋️" },
		  { title: "chair", character: "🪑" },
		  { title: "toilet", character: "🚽" },
		  { title: "shower", character: "🚿" },
		  { title: "bathtub", character: "🛁" },
		  { title: "razor", character: "🪒" },
		  { title: "lotion bottle", character: "🧴" },
		  { title: "safety pin", character: "🧷" },
		  { title: "broom", character: "🧹" },
		  { title: "basket", character: "🧺" },
		  { title: "roll of paper", character: "🧻" },
		  { title: "soap", character: "🧼" },
		  { title: "sponge", character: "🧽" },
		  { title: "fire extinguisher", character: "🧯" },
		  { title: "shopping cart", character: "🛒" },
		  { title: "cigarette", character: "🚬" },
		  { title: "coffin", character: "⚰️" },
		  { title: "funeral urn", character: "⚱️" },
		  { title: "moai", character: "🗿" },
		]);


		editor.plugins.get("Emoji").addItems("Symbols", [
		  { title: "atm sign", character: "🏧" },
		  { title: "litter in bin sign", character: "🚮" },
		  { title: "potable water", character: "🚰" },
		  { title: "wheelchair symbol", character: "♿" },
		  { title: "men’s room", character: "🚹" },
		  { title: "women’s room", character: "🚺" },
		  { title: "restroom", character: "🚻" },
		  { title: "baby symbol", character: "🚼" },
		  { title: "water closet", character: "🚾" },
		  { title: "passport control", character: "🛂" },
		  { title: "customs", character: "🛃" },
		  { title: "baggage claim", character: "🛄" },
		  { title: "left luggage", character: "🛅" },
		  { title: "warning", character: "⚠️" },
		  { title: "children crossing", character: "🚸" },
		  { title: "no entry", character: "⛔" },
		  { title: "prohibited", character: "🚫" },
		  { title: "no bicycles", character: "🚳" },
		  { title: "no smoking", character: "🚭" },
		  { title: "no littering", character: "🚯" },
		  { title: "non-potable water", character: "🚱" },
		  { title: "no pedestrians", character: "🚷" },
		  { title: "no mobile phones", character: "📵" },
		  { title: "no one under eighteen", character: "🔞" },
		  { title: "radioactive", character: "☢️" },
		  { title: "biohazard", character: "☣️" },
		  { title: "up arrow", character: "⬆️" },
		  { title: "up-right arrow", character: "↗️" },
		  { title: "right arrow", character: "➡️" },
		  { title: "down-right arrow", character: "↘️" },
		  { title: "down arrow", character: "⬇️" },
		  { title: "down-left arrow", character: "↙️" },
		  { title: "left arrow", character: "⬅️" },
		  { title: "up-left arrow", character: "↖️" },
		  { title: "up-down arrow", character: "↕️" },
		  { title: "left-right arrow", character: "↔️" },
		  { title: "right arrow curving left", character: "↩️" },
		  { title: "left arrow curving right", character: "↪️" },
		  { title: "right arrow curving up", character: "⤴️" },
		  { title: "right arrow curving down", character: "⤵️" },
		  { title: "clockwise vertical arrows", character: "🔃" },
		  { title: "counterclockwise arrows button", character: "🔄" },
		  { title: "back arrow", character: "🔙" },
		  { title: "end arrow", character: "🔚" },
		  { title: "on! arrow", character: "🔛" },
		  { title: "soon arrow", character: "🔜" },
		  { title: "top arrow", character: "🔝" },
		  { title: "place of worship", character: "🛐" },
		  { title: "atom symbol", character: "⚛️" },
		  { title: "om", character: "🕉️" },
		  { title: "star of david", character: "✡️" },
		  { title: "wheel of dharma", character: "☸️" },
		  { title: "yin yang", character: "☯️" },
		  { title: "latin cross", character: "✝️" },
		  { title: "orthodox cross", character: "☦️" },
		  { title: "star and crescent", character: "☪️" },
		  { title: "peace symbol", character: "☮️" },
		  { title: "menorah", character: "🕎" },
		  { title: "dotted six-pointed star", character: "🔯" },
		  { title: "aries", character: "♈" },
		  { title: "taurus", character: "♉" },
		  { title: "gemini", character: "♊" },
		  { title: "cancer", character: "♋" },
		  { title: "leo", character: "♌" },
		  { title: "virgo", character: "♍" },
		  { title: "libra", character: "♎" },
		  { title: "scorpio", character: "♏" },
		  { title: "sagittarius", character: "♐" },
		  { title: "capricorn", character: "♑" },
		  { title: "aquarius", character: "♒" },
		  { title: "pisces", character: "♓" },
		  { title: "ophiuchus", character: "⛎" },
		  { title: "shuffle tracks button", character: "🔀" },
		  { title: "repeat button", character: "🔁" },
		  { title: "repeat single button", character: "🔂" },
		  { title: "play button", character: "▶️" },
		  { title: "fast-forward button", character: "⏩" },
		  { title: "next track button", character: "⏭️" },
		  { title: "play or pause button", character: "⏯️" },
		  { title: "reverse button", character: "◀️" },
		  { title: "fast reverse button", character: "⏪" },
		  { title: "last track button", character: "⏮️" },
		  { title: "upwards button", character: "🔼" },
		  { title: "fast up button", character: "⏫" },
		  { title: "downwards button", character: "🔽" },
		  { title: "fast down button", character: "⏬" },
		  { title: "pause button", character: "⏸️" },
		  { title: "stop button", character: "⏹️" },
		  { title: "record button", character: "⏺️" },
		  { title: "eject button", character: "⏏️" },
		  { title: "cinema", character: "🎦" },
		  { title: "dim button", character: "🔅" },
		  { title: "bright button", character: "🔆" },
		  { title: "antenna bars", character: "📶" },
		  { title: "vibration mode", character: "📳" },
		  { title: "mobile phone off", character: "📴" },
		  { title: "female sign", character: "♀️" },
		  { title: "male sign", character: "♂️" },
		  { title: "multiply", character: "✖️" },
		  { title: "plus", character: "➕" },
		  { title: "minus", character: "➖" },
		  { title: "divide", character: "➗" },
		  { title: "infinity", character: "♾️" },
		  { title: "double exclamation mark", character: "‼️" },
		  { title: "exclamation question mark", character: "⁉️" },
		  { title: "question mark", character: "❓" },
		  { title: "white question mark", character: "❔" },
		  { title: "white exclamation mark", character: "❕" },
		  { title: "exclamation mark", character: "❗" },
		  { title: "wavy dash", character: "〰️" },
		  { title: "currency exchange", character: "💱" },
		  { title: "heavy dollar sign", character: "💲" },
		  { title: "medical symbol", character: "⚕️" },
		  { title: "recycling symbol", character: "♻️" },
		  { title: "fleur-de-lis", character: "⚜️" },
		  { title: "trident emblem", character: "🔱" },
		  { title: "name badge", character: "📛" },
		  { title: "japanese symbol for beginner", character: "🔰" },
		  { title: "hollow red circle", character: "⭕" },
		  { title: "check mark button", character: "✅" },
		  { title: "check box with check", character: "☑️" },
		  { title: "check mark", character: "✔️" },
		  { title: "cross mark", character: "❌" },
		  { title: "cross mark button", character: "❎" },
		  { title: "curly loop", character: "➰" },
		  { title: "double curly loop", character: "➿" },
		  { title: "part alternation mark", character: "〽️" },
		  { title: "eight-spoked asterisk", character: "✳️" },
		  { title: "eight-pointed star", character: "✴️" },
		  { title: "sparkle", character: "❇️" },
		  { title: "copyright", character: "©️" },
		  { title: "registered", character: "®️" },
		  { title: "trade mark", character: "™️" },
		  { title: "keycap: #", character: "#️⃣" },
		  { title: "keycap: *", character: "*️⃣" },
		  { title: "keycap: 0", character: "0️⃣" },
		  { title: "keycap: 1", character: "1️⃣" },
		  { title: "keycap: 2", character: "2️⃣" },
		  { title: "keycap: 3", character: "3️⃣" },
		  { title: "keycap: 4", character: "4️⃣" },
		  { title: "keycap: 5", character: "5️⃣" },
		  { title: "keycap: 6", character: "6️⃣" },
		  { title: "keycap: 7", character: "7️⃣" },
		  { title: "keycap: 8", character: "8️⃣" },
		  { title: "keycap: 9", character: "9️⃣" },
		  { title: "keycap: 10", character: "🔟" },
		  { title: "input latin uppercase", character: "🔠" },
		  { title: "input latin lowercase", character: "🔡" },
		  { title: "input numbers", character: "🔢" },
		  { title: "input symbols", character: "🔣" },
		  { title: "input latin letters", character: "🔤" },
		  { title: "a button (blood type)", character: "🅰️" },
		  { title: "ab button (blood type)", character: "🆎" },
		  { title: "b button (blood type)", character: "🅱️" },
		  { title: "cl button", character: "🆑" },
		  { title: "cool button", character: "🆒" },
		  { title: "free button", character: "🆓" },
		  { title: "information", character: "ℹ️" },
		  { title: "id button", character: "🆔" },
		  { title: "circled m", character: "Ⓜ️" },
		  { title: "new button", character: "🆕" },
		  { title: "ng button", character: "🆖" },
		  { title: "o button (blood type)", character: "🅾️" },
		  { title: "ok button", character: "🆗" },
		  { title: "p button", character: "🅿️" },
		  { title: "sos button", character: "🆘" },
		  { title: "up! button", character: "🆙" },
		  { title: "vs button", character: "🆚" },
		  { title: "japanese “here” button", character: "🈁" },
		  { title: "japanese “service charge” button", character: "🈂️" },
		  { title: "japanese “monthly amount” button", character: "🈷️" },
		  { title: "japanese “not free of charge” button", character: "🈶" },
		  { title: "japanese “reserved” button", character: "🈯" },
		  { title: "japanese “bargain” button", character: "🉐" },
		  { title: "japanese “discount” button", character: "🈹" },
		  { title: "japanese “free of charge” button", character: "🈚" },
		  { title: "japanese “prohibited” button", character: "🈲" },
		  { title: "japanese “acceptable” button", character: "🉑" },
		  { title: "japanese “application” button", character: "🈸" },
		  { title: "japanese “passing grade” button", character: "🈴" },
		  { title: "japanese “vacancy” button", character: "🈳" },
		  { title: "japanese “congratulations” button", character: "㊗️" },
		  { title: "japanese “secret” button", character: "㊙️" },
		  { title: "japanese “open for business” button", character: "🈺" },
		  { title: "japanese “no vacancy” button", character: "🈵" },
		  { title: "red circle", character: "🔴" },
		  { title: "orange circle", character: "🟠" },
		  { title: "yellow circle", character: "🟡" },
		  { title: "green circle", character: "🟢" },
		  { title: "blue circle", character: "🔵" },
		  { title: "purple circle", character: "🟣" },
		  { title: "brown circle", character: "🟤" },
		  { title: "black circle", character: "⚫" },
		  { title: "white circle", character: "⚪" },
		  { title: "red square", character: "🟥" },
		  { title: "orange square", character: "🟧" },
		  { title: "yellow square", character: "🟨" },
		  { title: "green square", character: "🟩" },
		  { title: "blue square", character: "🟦" },
		  { title: "purple square", character: "🟪" },
		  { title: "brown square", character: "🟫" },
		  { title: "black large square", character: "⬛" },
		  { title: "white large square", character: "⬜" },
		  { title: "black medium square", character: "◼️" },
		  { title: "white medium square", character: "◻️" },
		  { title: "black medium-small square", character: "◾" },
		  { title: "white medium-small square", character: "◽" },
		  { title: "black small square", character: "▪️" },
		  { title: "white small square", character: "▫️" },
		  { title: "large orange diamond", character: "🔶" },
		  { title: "large blue diamond", character: "🔷" },
		  { title: "small orange diamond", character: "🔸" },
		  { title: "small blue diamond", character: "🔹" },
		  { title: "red triangle pointed up", character: "🔺" },
		  { title: "red triangle pointed down", character: "🔻" },
		  { title: "diamond with a dot", character: "💠" },
		  { title: "radio button", character: "🔘" },
		  { title: "white square button", character: "🔳" },
		  { title: "black square button", character: "🔲" },
		]);


		editor.plugins.get("Emoji").addItems("Flags", [
		  { title: "chequered flag", character: "🏁" },
		  { title: "triangular flag", character: "🚩" },
		  { title: "crossed flags", character: "🎌" },
		  { title: "black flag", character: "🏴" },
		  { title: "white flag", character: "🏳️" },
		  { title: "rainbow flag", character: "🏳️‍🌈" },
		  { title: "pirate flag", character: "🏴‍☠️" },
		  { title: "flag: ascension island", character: "🇦🇨" },
		  { title: "flag: andorra", character: "🇦🇩" },
		  { title: "flag: united arab emirates", character: "🇦🇪" },
		  { title: "flag: afghanistan", character: "🇦🇫" },
		  { title: "flag: antigua & barbuda", character: "🇦🇬" },
		  { title: "flag: anguilla", character: "🇦🇮" },
		  { title: "flag: albania", character: "🇦🇱" },
		  { title: "flag: armenia", character: "🇦🇲" },
		  { title: "flag: angola", character: "🇦🇴" },
		  { title: "flag: antarctica", character: "🇦🇶" },
		  { title: "flag: argentina", character: "🇦🇷" },
		  { title: "flag: american samoa", character: "🇦🇸" },
		  { title: "flag: austria", character: "🇦🇹" },
		  { title: "flag: australia", character: "🇦🇺" },
		  { title: "flag: aruba", character: "🇦🇼" },
		  { title: "flag: Åland islands", character: "🇦🇽" },
		  { title: "flag: azerbaijan", character: "🇦🇿" },
		  { title: "flag: bosnia & herzegovina", character: "🇧🇦" },
		  { title: "flag: barbados", character: "🇧🇧" },
		  { title: "flag: bangladesh", character: "🇧🇩" },
		  { title: "flag: belgium", character: "🇧🇪" },
		  { title: "flag: burkina faso", character: "🇧🇫" },
		  { title: "flag: bulgaria", character: "🇧🇬" },
		  { title: "flag: bahrain", character: "🇧🇭" },
		  { title: "flag: burundi", character: "🇧🇮" },
		  { title: "flag: benin", character: "🇧🇯" },
		  { title: "flag: st. barthélemy", character: "🇧🇱" },
		  { title: "flag: bermuda", character: "🇧🇲" },
		  { title: "flag: brunei", character: "🇧🇳" },
		  { title: "flag: bolivia", character: "🇧🇴" },
		  { title: "flag: caribbean netherlands", character: "🇧🇶" },
		  { title: "flag: brazil", character: "🇧🇷" },
		  { title: "flag: bahamas", character: "🇧🇸" },
		  { title: "flag: bhutan", character: "🇧🇹" },
		  { title: "flag: bouvet island", character: "🇧🇻" },
		  { title: "flag: botswana", character: "🇧🇼" },
		  { title: "flag: belarus", character: "🇧🇾" },
		  { title: "flag: belize", character: "🇧🇿" },
		  { title: "flag: canada", character: "🇨🇦" },
		  { title: "flag: cocos (keeling) islands", character: "🇨🇨" },
		  { title: "flag: congo - kinshasa", character: "🇨🇩" },
		  { title: "flag: central african republic", character: "🇨🇫" },
		  { title: "flag: congo - brazzaville", character: "🇨🇬" },
		  { title: "flag: switzerland", character: "🇨🇭" },
		  { title: "flag: côte d’ivoire", character: "🇨🇮" },
		  { title: "flag: cook islands", character: "🇨🇰" },
		  { title: "flag: chile", character: "🇨🇱" },
		  { title: "flag: cameroon", character: "🇨🇲" },
		  { title: "flag: china", character: "🇨🇳" },
		  { title: "flag: colombia", character: "🇨🇴" },
		  { title: "flag: clipperton island", character: "🇨🇵" },
		  { title: "flag: costa rica", character: "🇨🇷" },
		  { title: "flag: cuba", character: "🇨🇺" },
		  { title: "flag: cape verde", character: "🇨🇻" },
		  { title: "flag: curaçao", character: "🇨🇼" },
		  { title: "flag: christmas island", character: "🇨🇽" },
		  { title: "flag: cyprus", character: "🇨🇾" },
		  { title: "flag: czechia", character: "🇨🇿" },
		  { title: "flag: germany", character: "🇩🇪" },
		  { title: "flag: diego garcia", character: "🇩🇬" },
		  { title: "flag: djibouti", character: "🇩🇯" },
		  { title: "flag: denmark", character: "🇩🇰" },
		  { title: "flag: dominica", character: "🇩🇲" },
		  { title: "flag: dominican republic", character: "🇩🇴" },
		  { title: "flag: algeria", character: "🇩🇿" },
		  { title: "flag: ceuta & melilla", character: "🇪🇦" },
		  { title: "flag: ecuador", character: "🇪🇨" },
		  { title: "flag: estonia", character: "🇪🇪" },
		  { title: "flag: egypt", character: "🇪🇬" },
		  { title: "flag: western sahara", character: "🇪🇭" },
		  { title: "flag: eritrea", character: "🇪🇷" },
		  { title: "flag: spain", character: "🇪🇸" },
		  { title: "flag: ethiopia", character: "🇪🇹" },
		  { title: "flag: european union", character: "🇪🇺" },
		  { title: "flag: finland", character: "🇫🇮" },
		  { title: "flag: fiji", character: "🇫🇯" },
		  { title: "flag: falkland islands", character: "🇫🇰" },
		  { title: "flag: micronesia", character: "🇫🇲" },
		  { title: "flag: faroe islands", character: "🇫🇴" },
		  { title: "flag: france", character: "🇫🇷" },
		  { title: "flag: gabon", character: "🇬🇦" },
		  { title: "flag: united kingdom", character: "🇬🇧" },
		  { title: "flag: grenada", character: "🇬🇩" },
		  { title: "flag: georgia", character: "🇬🇪" },
		  { title: "flag: french guiana", character: "🇬🇫" },
		  { title: "flag: guernsey", character: "🇬🇬" },
		  { title: "flag: ghana", character: "🇬🇭" },
		  { title: "flag: gibraltar", character: "🇬🇮" },
		  { title: "flag: greenland", character: "🇬🇱" },
		  { title: "flag: gambia", character: "🇬🇲" },
		  { title: "flag: guinea", character: "🇬🇳" },
		  { title: "flag: guadeloupe", character: "🇬🇵" },
		  { title: "flag: equatorial guinea", character: "🇬🇶" },
		  { title: "flag: greece", character: "🇬🇷" },
		  { title: "flag: south georgia & south sandwich islands", character: "🇬🇸" },
		  { title: "flag: guatemala", character: "🇬🇹" },
		  { title: "flag: guam", character: "🇬🇺" },
		  { title: "flag: guinea-bissau", character: "🇬🇼" },
		  { title: "flag: guyana", character: "🇬🇾" },
		  { title: "flag: hong kong sar china", character: "🇭🇰" },
		  { title: "flag: heard & mcdonald islands", character: "🇭🇲" },
		  { title: "flag: honduras", character: "🇭🇳" },
		  { title: "flag: croatia", character: "🇭🇷" },
		  { title: "flag: haiti", character: "🇭🇹" },
		  { title: "flag: hungary", character: "🇭🇺" },
		  { title: "flag: canary islands", character: "🇮🇨" },
		  { title: "flag: indonesia", character: "🇮🇩" },
		  { title: "flag: ireland", character: "🇮🇪" },
		  { title: "flag: israel", character: "🇮🇱" },
		  { title: "flag: isle of man", character: "🇮🇲" },
		  { title: "flag: india", character: "🇮🇳" },
		  { title: "flag: british indian ocean territory", character: "🇮🇴" },
		  { title: "flag: iraq", character: "🇮🇶" },
		  { title: "flag: iran", character: "🇮🇷" },
		  { title: "flag: iceland", character: "🇮🇸" },
		  { title: "flag: italy", character: "🇮🇹" },
		  { title: "flag: jersey", character: "🇯🇪" },
		  { title: "flag: jamaica", character: "🇯🇲" },
		  { title: "flag: jordan", character: "🇯🇴" },
		  { title: "flag: japan", character: "🇯🇵" },
		  { title: "flag: kenya", character: "🇰🇪" },
		  { title: "flag: kyrgyzstan", character: "🇰🇬" },
		  { title: "flag: cambodia", character: "🇰🇭" },
		  { title: "flag: kiribati", character: "🇰🇮" },
		  { title: "flag: comoros", character: "🇰🇲" },
		  { title: "flag: st. kitts & nevis", character: "🇰🇳" },
		  { title: "flag: north korea", character: "🇰🇵" },
		  { title: "flag: south korea", character: "🇰🇷" },
		  { title: "flag: kuwait", character: "🇰🇼" },
		  { title: "flag: cayman islands", character: "🇰🇾" },
		  { title: "flag: kazakhstan", character: "🇰🇿" },
		  { title: "flag: laos", character: "🇱🇦" },
		  { title: "flag: lebanon", character: "🇱🇧" },
		  { title: "flag: st. lucia", character: "🇱🇨" },
		  { title: "flag: liechtenstein", character: "🇱🇮" },
		  { title: "flag: sri lanka", character: "🇱🇰" },
		  { title: "flag: liberia", character: "🇱🇷" },
		  { title: "flag: lesotho", character: "🇱🇸" },
		  { title: "flag: lithuania", character: "🇱🇹" },
		  { title: "flag: luxembourg", character: "🇱🇺" },
		  { title: "flag: latvia", character: "🇱🇻" },
		  { title: "flag: libya", character: "🇱🇾" },
		  { title: "flag: morocco", character: "🇲🇦" },
		  { title: "flag: monaco", character: "🇲🇨" },
		  { title: "flag: moldova", character: "🇲🇩" },
		  { title: "flag: montenegro", character: "🇲🇪" },
		  { title: "flag: st. martin", character: "🇲🇫" },
		  { title: "flag: madagascar", character: "🇲🇬" },
		  { title: "flag: marshall islands", character: "🇲🇭" },
		  { title: "flag: north macedonia", character: "🇲🇰" },
		  { title: "flag: mali", character: "🇲🇱" },
		  { title: "flag: myanmar (burma)", character: "🇲🇲" },
		  { title: "flag: mongolia", character: "🇲🇳" },
		  { title: "flag: macao sar china", character: "🇲🇴" },
		  { title: "flag: northern mariana islands", character: "🇲🇵" },
		  { title: "flag: martinique", character: "🇲🇶" },
		  { title: "flag: mauritania", character: "🇲🇷" },
		  { title: "flag: montserrat", character: "🇲🇸" },
		  { title: "flag: malta", character: "🇲🇹" },
		  { title: "flag: mauritius", character: "🇲🇺" },
		  { title: "flag: maldives", character: "🇲🇻" },
		  { title: "flag: malawi", character: "🇲🇼" },
		  { title: "flag: mexico", character: "🇲🇽" },
		  { title: "flag: malaysia", character: "🇲🇾" },
		  { title: "flag: mozambique", character: "🇲🇿" },
		  { title: "flag: namibia", character: "🇳🇦" },
		  { title: "flag: new caledonia", character: "🇳🇨" },
		  { title: "flag: niger", character: "🇳🇪" },
		  { title: "flag: norfolk island", character: "🇳🇫" },
		  { title: "flag: nigeria", character: "🇳🇬" },
		  { title: "flag: nicaragua", character: "🇳🇮" },
		  { title: "flag: netherlands", character: "🇳🇱" },
		  { title: "flag: norway", character: "🇳🇴" },
		  { title: "flag: nepal", character: "🇳🇵" },
		  { title: "flag: nauru", character: "🇳🇷" },
		  { title: "flag: niue", character: "🇳🇺" },
		  { title: "flag: new zealand", character: "🇳🇿" },
		  { title: "flag: oman", character: "🇴🇲" },
		  { title: "flag: panama", character: "🇵🇦" },
		  { title: "flag: peru", character: "🇵🇪" },
		  { title: "flag: french polynesia", character: "🇵🇫" },
		  { title: "flag: papua new guinea", character: "🇵🇬" },
		  { title: "flag: philippines", character: "🇵🇭" },
		  { title: "flag: pakistan", character: "🇵🇰" },
		  { title: "flag: poland", character: "🇵🇱" },
		  { title: "flag: st. pierre & miquelon", character: "🇵🇲" },
		  { title: "flag: pitcairn islands", character: "🇵🇳" },
		  { title: "flag: puerto rico", character: "🇵🇷" },
		  { title: "flag: palestinian territories", character: "🇵🇸" },
		  { title: "flag: portugal", character: "🇵🇹" },
		  { title: "flag: palau", character: "🇵🇼" },
		  { title: "flag: paraguay", character: "🇵🇾" },
		  { title: "flag: qatar", character: "🇶🇦" },
		  { title: "flag: réunion", character: "🇷🇪" },
		  { title: "flag: romania", character: "🇷🇴" },
		  { title: "flag: serbia", character: "🇷🇸" },
		  { title: "flag: russia", character: "🇷🇺" },
		  { title: "flag: rwanda", character: "🇷🇼" },
		  { title: "flag: saudi arabia", character: "🇸🇦" },
		  { title: "flag: solomon islands", character: "🇸🇧" },
		  { title: "flag: seychelles", character: "🇸🇨" },
		  { title: "flag: sudan", character: "🇸🇩" },
		  { title: "flag: sweden", character: "🇸🇪" },
		  { title: "flag: singapore", character: "🇸🇬" },
		  { title: "flag: st. helena", character: "🇸🇭" },
		  { title: "flag: slovenia", character: "🇸🇮" },
		  { title: "flag: svalbard & jan mayen", character: "🇸🇯" },
		  { title: "flag: slovakia", character: "🇸🇰" },
		  { title: "flag: sierra leone", character: "🇸🇱" },
		  { title: "flag: san marino", character: "🇸🇲" },
		  { title: "flag: senegal", character: "🇸🇳" },
		  { title: "flag: somalia", character: "🇸🇴" },
		  { title: "flag: suriname", character: "🇸🇷" },
		  { title: "flag: south sudan", character: "🇸🇸" },
		  { title: "flag: são tomé & príncipe", character: "🇸🇹" },
		  { title: "flag: el salvador", character: "🇸🇻" },
		  { title: "flag: sint maarten", character: "🇸🇽" },
		  { title: "flag: syria", character: "🇸🇾" },
		  { title: "flag: eswatini", character: "🇸🇿" },
		  { title: "flag: tristan da cunha", character: "🇹🇦" },
		  { title: "flag: turks & caicos islands", character: "🇹🇨" },
		  { title: "flag: chad", character: "🇹🇩" },
		  { title: "flag: french southern territories", character: "🇹🇫" },
		  { title: "flag: togo", character: "🇹🇬" },
		  { title: "flag: thailand", character: "🇹🇭" },
		  { title: "flag: tajikistan", character: "🇹🇯" },
		  { title: "flag: tokelau", character: "🇹🇰" },
		  { title: "flag: timor-leste", character: "🇹🇱" },
		  { title: "flag: turkmenistan", character: "🇹🇲" },
		  { title: "flag: tunisia", character: "🇹🇳" },
		  { title: "flag: tonga", character: "🇹🇴" },
		  { title: "flag: turkey", character: "🇹🇷" },
		  { title: "flag: trinidad & tobago", character: "🇹🇹" },
		  { title: "flag: tuvalu", character: "🇹🇻" },
		  { title: "flag: taiwan", character: "🇹🇼" },
		  { title: "flag: tanzania", character: "🇹🇿" },
		  { title: "flag: ukraine", character: "🇺🇦" },
		  { title: "flag: uganda", character: "🇺🇬" },
		  { title: "flag: u.s. outlying islands", character: "🇺🇲" },
		  { title: "flag: united nations", character: "🇺🇳" },
		  { title: "flag: united states", character: "🇺🇸" },
		  { title: "flag: uruguay", character: "🇺🇾" },
		  { title: "flag: uzbekistan", character: "🇺🇿" },
		  { title: "flag: vatican city", character: "🇻🇦" },
		  { title: "flag: st. vincent & grenadines", character: "🇻🇨" },
		  { title: "flag: venezuela", character: "🇻🇪" },
		  { title: "flag: british virgin islands", character: "🇻🇬" },
		  { title: "flag: u.s. virgin islands", character: "🇻🇮" },
		  { title: "flag: vietnam", character: "🇻🇳" },
		  { title: "flag: vanuatu", character: "🇻🇺" },
		  { title: "flag: wallis & futuna", character: "🇼🇫" },
		  { title: "flag: samoa", character: "🇼🇸" },
		  { title: "flag: kosovo", character: "🇽🇰" },
		  { title: "flag: yemen", character: "🇾🇪" },
		  { title: "flag: mayotte", character: "🇾🇹" },
		  { title: "flag: south africa", character: "🇿🇦" },
		  { title: "flag: zambia", character: "🇿🇲" },
		  { title: "flag: zimbabwe", character: "🇿🇼" },
		  { title: "flag: england", character: "🏴󠁧󠁢󠁥󠁮󠁧󠁿" },
		  { title: "flag: scotland", character: "🏴󠁧󠁢󠁳󠁣󠁴󠁿" },
		  { title: "flag: wales", character: "🏴󠁧󠁢󠁷󠁬󠁳󠁿" },
		]);
	}
}
